import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "variant", "is-full-width", "disabled", "size", "custom-class", "is-loading", "loading-text"]

import { ButtonVariant } from '@lukso/web-components/dist/components'
import { ref } from 'vue'

type Props = {
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  variant?: ButtonVariant
  isFullWidth?: boolean
  size?: 'small' | 'medium'
  customClass?: string
  isLoading?: boolean
  loadingText?: string
}

type Emits = {
  (event: 'on-long-press-complete'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    type: { default: 'button' },
    disabled: { type: Boolean, default: false },
    variant: { default: 'primary' },
    isFullWidth: { type: Boolean, default: false },
    size: { default: 'medium' },
    customClass: { default: '' },
    isLoading: { type: Boolean, default: undefined },
    loadingText: { default: undefined }
  },
  emits: ["on-long-press-complete"],
  setup(__props: any, { emit: __emit }) {

const buttonRef = ref<HTMLElement>()

const emits = __emit



const onLongClickEnd = () => {
  emits('on-long-press-complete')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("lukso-button", {
    ref_key: "buttonRef",
    ref: buttonRef,
    type: _ctx.type,
    variant: _ctx.variant,
    "is-full-width": _ctx.isFullWidth ? true : undefined,
    disabled: _ctx.disabled ? true : undefined,
    size: _ctx.size,
    "custom-class": _ctx.customClass,
    "is-loading": _ctx.isLoading ? true : undefined,
    "loading-text": _ctx.loadingText,
    onOnLongPressComplete: onLongClickEnd
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})